var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    d: "M17.66,89.383 c0,3.38-2.739,6.117-6.117,6.117c-3.379,0-6.121-2.737-6.121-6.117c0-3.379,2.742-6.116,6.121-6.116 C14.919,83.267,17.66,86.004,17.66,89.383z M88.461,4.5c-3.379,0-6.117,2.736-6.117,6.117c0,3.38,2.738,6.12,6.117,6.12 c3.381,0,6.117-2.741,6.117-6.12C94.578,7.237,91.842,4.5,88.461,4.5z M16.054,85.249l68.481-69.938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.0a41fe14a0b674efa22f6331b2133893.svg";
export { ForwardRef as ReactComponent };